import { Period } from '../context/PeriodProvider';
import { fetchAndParse } from '../lib/utils';
import { ClientConfig } from '../types/ClientConfig';
import { Consumption } from '../types/Consumption';
import { Role } from '../types/Role';
import { BaseClient, Endpoints, getHeaders } from './BaseClient';

export const ConsumptionClient = (config: ClientConfig) => {
    const { accessToken, userRole, param = '' } = config;
    const headers = getHeaders(accessToken);
    const baseClientConfig = {
        useAdminRoute: userRole === Role.ADMIN && param !== '',
    };

    const getConsumption = (period: Period): Promise<Consumption> => {
        const apiUrl = `${BaseClient(baseClientConfig).getApiUrl(Endpoints.CONSUMPTION)}/${param}?quarter=${period.quarter}&year=${period.year}`;

        return fetchAndParse<Consumption>(apiUrl, {
            headers,
        });
    };

    return {
        getConsumption,
    };
};
